import React__default from 'react';
import { Heading } from '@grandvisionhq/elements';

const SolutionsProductDetails = (props)=>{
    if (Object.values(props).every((productDetails)=>productDetails === ''
    )) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "subheading1"
    }, props.headerTitle), /*#__PURE__*/ React__default.createElement("ul", null, Object.keys(props).filter((el)=>el !== 'headerTitle'
    ).map((key)=>props[key] ? /*#__PURE__*/ React__default.createElement("li", {
            key: key
        }, props[key]) : null
    )));
};
var SolutionsProductDetails$1 = SolutionsProductDetails;

export { SolutionsProductDetails$1 as default };
//# sourceMappingURL=SolutionsProductDetails.js.map
